import React, { useState, createContext } from "react";

export const AuthContext = createContext();